import React from 'react';
import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import DeliveredToggle from 'Components/Account/Filters/components/FiltersPopover/components/DeliveredToggle/DeliveredToggle';
import cypressIds from 'Components/cypress_ids.json';
import Spacer from 'Components/Spacer/Spacer';
import { applyCypressData } from 'Utilities/helpers';

import AccountDateRangeFilter from '../../AccountDateRangeFilter/AccountDateRangeFilter';
import AccountPurchaseCompleteStatusFilter from '../AccountPurchaseCompleteStatusFilter';

import LocalTexts from './AccountPurchaseCompleteMobileModal.texts.json';
import type { AccountPurchaseCompleteMobileModalProps } from './AccountPurchaseCompleteMobileModal.types';

import styles from './AccountPurchaseCompleteMobileModal.module.scss';

const LocalT = new MDText(LocalTexts);

const {
	buttons: { purchaseCompleteMobileFilter },
} = cypressIds;

const AccountPurchaseCompleteMobileModal: React.FC<AccountPurchaseCompleteMobileModalProps> = ({
	count = 0,
	onClearAllFilters,
	onShowVehicles,
}) => {
	const handleClearAllFilters = (): void => {
		onClearAllFilters?.();
	};

	const handleShowVehicles = (): void => {
		onShowVehicles?.();
	};

	return (
		<div className={styles.container}>
			<section className={styles.section}>
				<h3 className={styles.title}>{LocalT.translate('title')}</h3>
				<AccountDateRangeFilter
					cypressDataId={purchaseCompleteMobileFilter.purchaseCompleteMobileDateFilter}
					label={String(LocalT.translate('dateLabel'))}
					showMobileButtonOverlay={false}
				/>
				<Spacer />
				<AccountPurchaseCompleteStatusFilter
					cypressDataId={purchaseCompleteMobileFilter.purchaseCompleteMobileStatusFilter}
					label={String(LocalT.translate('statusLabel'))}
					selectClassName={styles.purchaseStatusFilter}
				/>
				<Spacer />
				<div className={styles.toggleWrapper}>
					<DeliveredToggle />
				</div>
			</section>

			<section className={styles.section}>
				<Spacer />
				<div className={styles.buttonContainer}>
					<Button
						label={String(LocalT.translate('showVehicles', { count }))}
						onClick={handleShowVehicles}
						{...applyCypressData(purchaseCompleteMobileFilter.purchaseCompleteMobileShowVehiclesButton)}
					/>
					<Button
						label={String(LocalT.translate('clearAllFilters'))}
						onClick={handleClearAllFilters}
						variant="secondary"
						{...applyCypressData(purchaseCompleteMobileFilter.purchaseCompleteMobileClearFiltersButton)}
					/>
				</div>
			</section>
		</div>
	);
};

export default AccountPurchaseCompleteMobileModal;
